import React, { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { RootState } from "@src/reducers/store";
import { useServiceSupportSSE } from "./sse-service-hooks/use-service-support-sse";
import { useMachineEventsSSE } from "./sse-service-hooks/use-service-machine-events-sse";
import { useServiceVPNManagerSSE } from "./sse-service-hooks/use-service-vpn-manager-sse";

const LOG_THROTTLE_MS = 60000;

export const SSEProvider = ({ children }: { children: React.ReactNode }) => {
  const globalErrors = useSelector(
    (state: RootState) => state.sseSlice.globalErrors,
  );

  const lastLoggedAtHash = useRef<{ [key: string]: number | undefined }>({});

  // Service Support SSE
  useServiceSupportSSE();

  // Service Machine Events SSE
  // useMachineEventsSSE();

  // Service VPN Manager SSE
  useServiceVPNManagerSSE();

  const errorKey = globalErrors.map(({ service }) => service).join(",");

  useEffect(() => {
    if (globalErrors.length === 0) {
      lastLoggedAtHash.current = {};
      return;
    }

    globalErrors.forEach(({ service, message }) => {
      const now = Date.now();
      const lastLogged = lastLoggedAtHash.current[service];
      const shouldLog =
        lastLogged === undefined || now - lastLogged >= LOG_THROTTLE_MS;

      if (!shouldLog) return;

      console.warn(`[SSE] ${service} disconnected: ${message}`);
      lastLoggedAtHash.current[service] = now;
    });
  }, [errorKey, globalErrors]);

  return <>{children}</>;
};
